export type AccessMode = 'preview' | 'unlocked';

export const PREVIEW_NODE_LIMIT = 10;

export function canCreateNodeInAccessMode(accessMode: AccessMode, currentNodeCount: number): boolean {
  return accessMode === 'unlocked' || currentNodeCount < PREVIEW_NODE_LIMIT;
}
